import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, StarIcon } from 'lucide-react';
import { QuoteForm } from './QuoteForm';
import { images, site } from '../data/site';
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-ink" data-id="element-207" data-mp="9lv0eoeuobus">
      <img src={images.hero} alt="Home Repair MD technician patching drywall in a Las Vegas home" className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-208" data-mp="4lyw0o28qiep" />
      <div className="absolute inset-0 bg-ink/75 lg:bg-ink/70" aria-hidden="true" data-id="element-209" data-mp="xannrwhepbds" />

      <div className="relative mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:gap-16 lg:px-8 lg:py-24" data-id="element-210" data-mp="x8jojrugd0ju">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-211" data-mp="nb6lzq59zhn3">
          <div className="flex items-center gap-2 text-white" data-id="element-212" data-mp="381xlmzcsr4ap">
            <div className="flex" aria-hidden="true" data-id="element-213" data-mp="384s78u7jqv5p">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-[#FFC531] text-[#FFC531]" data-id="element-214" data-mp="3o7lprkf2kuls" data-mpi={i} />)}
            </div>
            <span className="text-sm font-semibold" data-id="element-215" data-mp="39aurjeh4toxr">5-star rated across the Las Vegas Valley</span>
          </div>

          <h1 className="mt-5 font-display text-5xl font-extrabold uppercase leading-[0.95] text-white sm:text-6xl lg:text-7xl" data-id="element-216" data-mp="3e8egb8bghk3y">
            Your home’s
            <br data-id="element-217" data-mp="30g6ozw2xylcn" />
            <span className="text-brand" data-id="element-218" data-mp="358ho4wpuy345">repair doctor</span>
            <br data-id="element-219" data-mp="35a2jupnwrs3l" />
            is in.
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/85" data-id="element-220" data-mp="2qkmrj58qbels">
            Drywall, painting, flooring, stucco and every repair in between — done right the first time by a
            licensed, family-owned Las Vegas contractor.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-221" data-mp="2hlj7nz1qmv68">
            <a href={site.phoneHref} className="flex items-center justify-center gap-3 rounded-lg bg-brand px-7 py-4 font-display text-2xl font-bold text-white transition-colors duration-150 hover:bg-brand-dark" data-id="element-222" data-mp="2ljh0rcymq1ew">
              <PhoneIcon className="h-6 w-6" aria-hidden="true" data-id="element-223" data-mp="ibypocqjh226" />
              {site.phone}
            </a>
            <a href="#estimate" className="flex items-center justify-center rounded-lg border-2 border-white/80 px-7 py-4 font-display text-2xl font-bold text-white transition-colors duration-150 hover:bg-white hover:text-ink" data-id="element-224" data-mp="ddnh05bzcxlj">
              Build My Estimate
            </a>
          </div>

          <dl className="mt-10 grid max-w-lg grid-cols-3 divide-x divide-white/20 border-t border-white/20 pt-6 text-white" data-id="element-225" data-mp="111eqz2a1syjn">
            <div className="pr-4" data-id="element-226" data-mp="x37a87fl3x8g">
              <dt className="text-xs font-medium text-white/70" data-id="element-227" data-mp="3ltglflt1eim8">Response time</dt>
              <dd className="font-display text-2xl font-bold" data-id="element-228" data-mp="3hrd9yx6dbe0y">&lt; 24 hrs</dd>
            </div>
            <div className="px-4" data-id="element-229" data-mp="1x9b3owgzwtag">
              <dt className="text-xs font-medium text-white/70" data-id="element-230" data-mp="1xa43telg8kjm">Licensed</dt>
              <dd className="font-display text-2xl font-bold" data-id="element-231" data-mp="21amvn8ncdqlt">#0093347</dd>
            </div>
            <div className="pl-4" data-id="element-232" data-mp="269zfdkix2hk6">
              <dt className="text-xs font-medium text-white/70" data-id="element-233" data-mp="268y5hjdn0141">Ownership</dt>
              <dd className="font-display text-2xl font-bold" data-id="element-234" data-mp="2b197qsvunyzr">Family</dd>
            </div>
          </dl>
        </motion.div>

        <motion.div id="quote" initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl bg-white p-6 shadow-2xl sm:p-8" data-id="element-235" data-mp="2fz0wxf541709">
          <h2 className="font-display text-3xl font-bold leading-tight text-ink" data-id="element-236" data-mp="2tztuk8qpki7l">Get your free quote</h2>
          <p className="mb-5 mt-1 text-ink-muted" data-id="element-237" data-mp="un9axqsawpgq">Fixed pricing. No surprises. Takes 30 seconds.</p>
          <QuoteForm data-id="element-238" data-mp="zkrbass95wd4" />
        </motion.div>
      </div>
    </section>;
}